/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Ios_DismissInputs */



/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Notifications_Ios_DismissInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_ios_dismiss = /** @type {((inputs?: Notifications_Ios_DismissInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Ios_DismissInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compris")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entendido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entendido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Capito")
	return /** @type {LocalizedString} */ ("Got it")
});